import "/__w/1/s/BotFramework-WebChat/packages/component/src/Activity/CarouselFilmStrip.module_built.css";
const classes = {"carousel-filmstrip--hide-avatar":"wzsijdG_carousel-filmstrip--hide-avatar","carousel-filmstrip--extra-trailing":"wzsijdG_carousel-filmstrip--extra-trailing","carousel-filmstrip--hide-nub":"wzsijdG_carousel-filmstrip--hide-nub","carousel-filmstrip--show-nub":"wzsijdG_carousel-filmstrip--show-nub","carousel-filmstrip__nub-pad":"wzsijdG_carousel-filmstrip__nub-pad","carousel-filmstrip--top-callout":"wzsijdG_carousel-filmstrip--top-callout","carousel-filmstrip--no-message":"wzsijdG_carousel-filmstrip--no-message","carousel-filmstrip__filler":"wzsijdG_carousel-filmstrip__filler","carousel-filmstrip__main":"wzsijdG_carousel-filmstrip__main","carousel-filmstrip__message":"wzsijdG_carousel-filmstrip__message","carousel-filmstrip__alignment-pad":"wzsijdG_carousel-filmstrip__alignment-pad","carousel-filmstrip--show-avatar":"wzsijdG_carousel-filmstrip--show-avatar","carousel-filmstrip__avatar":"wzsijdG_carousel-filmstrip__avatar","carousel-filmstrip__complimentary-content":"wzsijdG_carousel-filmstrip__complimentary-content","carousel-filmstrip__content":"wzsijdG_carousel-filmstrip__content","carousel-filmstrip__status":"wzsijdG_carousel-filmstrip__status","carousel-filmstrip__complimentary":"wzsijdG_carousel-filmstrip__complimentary","carousel-filmstrip__avatar-gutter":"wzsijdG_carousel-filmstrip__avatar-gutter","carousel-filmstrip__attachments":"wzsijdG_carousel-filmstrip__attachments","carousel-filmstrip__bubble":"wzsijdG_carousel-filmstrip__bubble","carousel-filmstrip":"wzsijdG_carousel-filmstrip"}
export default classes

const _carousel_filmstrip__hide_avatar0 = classes["carousel-filmstrip--hide-avatar"]
export { _carousel_filmstrip__hide_avatar0 as "carousel-filmstrip--hide-avatar" }

const _carousel_filmstrip__extra_trailing0 = classes["carousel-filmstrip--extra-trailing"]
export { _carousel_filmstrip__extra_trailing0 as "carousel-filmstrip--extra-trailing" }

const _carousel_filmstrip__hide_nub0 = classes["carousel-filmstrip--hide-nub"]
export { _carousel_filmstrip__hide_nub0 as "carousel-filmstrip--hide-nub" }

const _carousel_filmstrip__show_nub0 = classes["carousel-filmstrip--show-nub"]
export { _carousel_filmstrip__show_nub0 as "carousel-filmstrip--show-nub" }

const _carousel_filmstrip__nub_pad0 = classes["carousel-filmstrip__nub-pad"]
export { _carousel_filmstrip__nub_pad0 as "carousel-filmstrip__nub-pad" }

const _carousel_filmstrip__top_callout0 = classes["carousel-filmstrip--top-callout"]
export { _carousel_filmstrip__top_callout0 as "carousel-filmstrip--top-callout" }

const _carousel_filmstrip__no_message0 = classes["carousel-filmstrip--no-message"]
export { _carousel_filmstrip__no_message0 as "carousel-filmstrip--no-message" }

const _carousel_filmstrip__filler0 = classes["carousel-filmstrip__filler"]
export { _carousel_filmstrip__filler0 as "carousel-filmstrip__filler" }

const _carousel_filmstrip__main0 = classes["carousel-filmstrip__main"]
export { _carousel_filmstrip__main0 as "carousel-filmstrip__main" }

const _carousel_filmstrip__message0 = classes["carousel-filmstrip__message"]
export { _carousel_filmstrip__message0 as "carousel-filmstrip__message" }

const _carousel_filmstrip__alignment_pad0 = classes["carousel-filmstrip__alignment-pad"]
export { _carousel_filmstrip__alignment_pad0 as "carousel-filmstrip__alignment-pad" }

const _carousel_filmstrip__show_avatar0 = classes["carousel-filmstrip--show-avatar"]
export { _carousel_filmstrip__show_avatar0 as "carousel-filmstrip--show-avatar" }

const _carousel_filmstrip__avatar0 = classes["carousel-filmstrip__avatar"]
export { _carousel_filmstrip__avatar0 as "carousel-filmstrip__avatar" }

const _carousel_filmstrip__complimentary_content0 = classes["carousel-filmstrip__complimentary-content"]
export { _carousel_filmstrip__complimentary_content0 as "carousel-filmstrip__complimentary-content" }

const _carousel_filmstrip__content0 = classes["carousel-filmstrip__content"]
export { _carousel_filmstrip__content0 as "carousel-filmstrip__content" }

const _carousel_filmstrip__status0 = classes["carousel-filmstrip__status"]
export { _carousel_filmstrip__status0 as "carousel-filmstrip__status" }

const _carousel_filmstrip__complimentary0 = classes["carousel-filmstrip__complimentary"]
export { _carousel_filmstrip__complimentary0 as "carousel-filmstrip__complimentary" }

const _carousel_filmstrip__avatar_gutter0 = classes["carousel-filmstrip__avatar-gutter"]
export { _carousel_filmstrip__avatar_gutter0 as "carousel-filmstrip__avatar-gutter" }

const _carousel_filmstrip__attachments0 = classes["carousel-filmstrip__attachments"]
export { _carousel_filmstrip__attachments0 as "carousel-filmstrip__attachments" }

const _carousel_filmstrip__bubble0 = classes["carousel-filmstrip__bubble"]
export { _carousel_filmstrip__bubble0 as "carousel-filmstrip__bubble" }

const _carousel_filmstrip0 = classes["carousel-filmstrip"]
export { _carousel_filmstrip0 as "carousel-filmstrip" }
